function bootstrapToast() {
  return globalThis.bootstrap?.Toast;
}

const containerId = 'desaldata-toast-container';

function ensureContainer() {
  let container = document.getElementById(containerId);
  if (container) return container;

  container = document.createElement('div');
  container.id = containerId;
  container.className = 'toast-container position-fixed top-0 end-0 p-3';
  container.style.zIndex = '1090';
  document.body.appendChild(container);
  return container;
}

function showToast(message, variant) {
  const Toast = bootstrapToast();
  if (!Toast) return;

  const container = ensureContainer();
  const toastElement = document.createElement('div');
  toastElement.className = `toast align-items-center text-bg-${variant} border-0`;
  toastElement.setAttribute('role', 'alert');
  toastElement.innerHTML = `
    <div class="d-flex">
      <div class="toast-body">${message}</div>
      <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
    </div>
  `;

  container.appendChild(toastElement);
  const toast = Toast.getOrCreateInstance(toastElement, {
    delay: globalThis.toastr?.options?.timeOut || 5000
  });
  toastElement.addEventListener('hidden.bs.toast', () => toastElement.remove());
  toast.show();
}

export function initToastr() {
  globalThis.toastr = {
    options: {
      closeButton: true,
      timeOut: 5000
    },
    info(message) {
      showToast(message, 'primary');
    },
    error(message) {
      showToast(message, 'danger');
    }
  };
}
